import { useMutation, useQueryClient } from 'libs/query'
import { useTranslation } from 'libs/i18n'
import { useAxiosPrivate, useToast } from 'shared/hooks'
import { queryKeys } from 'config/queryKeys'
import { apiRoutes } from 'config/apiRoutes'

type UseMarkAsPaidMutationProps = {
	onSettled: () => void
	clearSelection: () => void
}

export const useMarkAsPaidMutation = ({
	onSettled,
	clearSelection
}: UseMarkAsPaidMutationProps) => {
	const { t } = useTranslation()
	const axiosPrivate = useAxiosPrivate()
	const queryClient = useQueryClient()

	const { mutate: markAsPaidMutation } = useMutation({
		mutationFn: (ids: number[]) =>
			axiosPrivate.post(apiRoutes.payoutsBulkStatus, {
				status: 'paid',
				ids
			}),
		onSuccess: () => {
			useToast({
				type: 'success',
				message: t('Payouts completed')
			})()

			queryClient.invalidateQueries({ queryKey: queryKeys.payouts.all })
			clearSelection()
		},
		onError: () => {
			useToast({
				type: 'error',
				message: t('Something went wrong')
			})()
		},
		onSettled: () => {
			onSettled()
		}
	})

	return {
		markAsPaidMutation
	}
}
